var scope_0 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/9ed0e2a3f211ef8ee33cb9c6bbcd6725.js').default;
var scope_1 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/dd23029ad17b25c045feadabea53490b.js').default;export default
        Object.assign({}, scope_0,
scope_1 )
    